module.exports = __webpack_public_path__ + "170bccfb4f0ca435054beb35007b13a6.svg";